import styled from 'styled-components'
import { Col } from 'antd'

const AntColStyled = styled(Col)``

export default AntColStyled
